import { render, staticRenderFns } from "./bjdk.vue?vue&type=template&id=f09ddd38&"
import script from "./bjdk.vue?vue&type=script&lang=js&"
export * from "./bjdk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports